/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AdditionalResourceDetailsForFinopsGovernanceSystem extends models.AdditionalResourceDetailsForFinopsReservationRecommendations {
    constructor() {
        super();
        this.setDiscriminator("AdditionalResourceDetailsForFinopsGovernanceSystem");
    }

    getFixupPrototypeFunction() { return AdditionalResourceDetailsForFinopsGovernanceSystem.fixupPrototype; }

    static newInstance(model: Partial<AdditionalResourceDetailsForFinopsGovernanceSystem>): AdditionalResourceDetailsForFinopsGovernanceSystem {
        let obj = Object.assign(new AdditionalResourceDetailsForFinopsGovernanceSystem(), model);
        AdditionalResourceDetailsForFinopsGovernanceSystem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AdditionalResourceDetailsForFinopsGovernanceSystem>): AdditionalResourceDetailsForFinopsGovernanceSystem {
        if (!model) return null;
        return AdditionalResourceDetailsForFinopsGovernanceSystem.newInstance(<AdditionalResourceDetailsForFinopsGovernanceSystem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AdditionalResourceDetailsForFinopsGovernanceSystem) {
        if (!obj) return;

        models.AdditionalResourceDetailsForFinopsGovernanceSystem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AdditionalResourceDetailsForFinopsGovernanceSystem): boolean {
        if (models.AdditionalResourceDetailsForFinopsReservationRecommendations.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AdditionalResourceDetailsForFinopsGovernanceSystem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.savings_percentage === undefined) {
            this.savings_percentage = 0;
        }
    }

    /**
     * percentage of savings
     */
    savings_percentage: number;

}
